import type * as Sentry from "@sentry/node";

type Integration = ReturnType<Exclude<Sentry.NodeOptions["integrations"], undefined | unknown[]>>[number];

export function resolveIntegrations(
  integrations: Sentry.NodeOptions["integrations"],
  defaults: Integration[],
): Integration[] {
  if (typeof integrations === "function") {
    return integrations(defaults);
  }
  if (Array.isArray(integrations)) {
    return integrations;
  }
  return [];
}
